/* eslint-disable no-unused-expressions */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-use-before-define */
import { filterByNoUndefined } from '../../shared/utils/UtilsHelper';
import { getWidgetSet, setConfig } from './widgetPool';
import {
    changePriceFilter,
    changePropertiesByCountryCode,
    changeCheckboxesFilter,
} from './hotels';
import { DEFAULT_FALLBACK_LANGUAGE } from 'Constants/App';
import { changeCurrency, setCurrencyType, setRoomsWarning, setSearchKey } from 'Actions/search';
import AVAILABLE_LANGUAGES from 'Constants/Languages';
import { DEFAULT_VALUES, ECHO_WIDGET } from 'Constants/WidgetConfig';
import { WidgetConfigHelper } from 'Helpers';
import { API } from 'Services';
import { sanitizeDate } from 'Shared/utils/DatesHelper';
import { getCroppedImages } from 'Shared/utils/ImageHelper';


const moment = require('moment');

export function dataRequestStart() {
    return { type: 'DATA_REQUEST_START' };
}

export function dataRequestSuccess(response) {
    return { type: 'DATA_REQUEST_SUCCESS', payload: response };
}

export function replaceSettingData(data) {
    return { type: 'DATA_REPLACEMENT', payload: data };
}

export function dataRequestFailure(data) {
    return { type: 'DATA_REQUEST_FAILURE', payload: data };
}

export function ratesAndOffersRequestStart() {
    return { type: 'RATES_AND_OFFERS_REQUEST_START' };
}

export function ratesAndOffersRequestSuccess(response) {
    return { type: 'RATES_AND_OFFERS_REQUEST_SUCCESS', payload: response };
}

export function ratesAndOffersRequestFailure(data) {
    return { type: 'RATES_AND_OFFERS_REQUEST_FAILURE', payload: data };
}

export function futureOffersRequestStart() {
    return { type: 'FUTURE_OFFERS_REQUEST_START' };
}

export function futureOffersRequestSuccess(response) {
    return { type: 'FUTURE_OFFERS_REQUEST_SUCCESS', payload: response };
}

export function futureOffersRequestFailure(data) {
    return { type: 'FUTURE_OFFERS_REQUEST_FAILURE', payload: data };
}

export function hotelProfileRequestStart() {
    return { type: 'HOTEL_PROFILE_REQUEST_START' };
}

export function hotelProfileRequestSuccess(response) {
    return { type: 'HOTEL_PROFILE_REQUEST_SUCCESS', payload: response };
}

export function hotelProfileRequestFailure(data) {
    return { type: 'HOTEL_PROFILE_REQUEST_FAILURE', payload: data };
}

export const getStyles = () => async (dispatch, getState) => {
    const search = getState()?.search?.data || {};
    const settings = getState()?.settings?.data || {};
    const {
        isMultiProperty,
        channelId,
        checkIn,
        checkOut,
        ipAddress,
        userAgent,
        propertyCode,
        language,
        customizations,
        promotionalCodeEnabled,
    } = settings;
    const { stylesUrl, isUsingInlineStyles } = customizations || {};
    const isStyleRequestRequired = !isMultiProperty && !!stylesUrl && !isUsingInlineStyles;

    if (isStyleRequestRequired) {
        const params = {
            isMultiProperty,
            channelId,
            checkIn: search.checkIn || checkIn,
            checkOut: search.checkOut || checkOut,
            userUserAgent: search.userAgent || userAgent,
            propertyCode,
            language,
            stylesUrl,
            userIP: ipAddress,
            propertyId: isMultiProperty ? channelId : propertyCode,
            context: isMultiProperty ? 'channel' : 'hotel',
            page: isMultiProperty ? 'hotelslist' : 'roomslist',
            promotionCodes: promotionalCodeEnabled && search.clientPromoCode ? [ search.clientPromoCode ] : [],
        };

        try {
            const stylesResponse = await API.getStyles(params);

            if (stylesResponse) {
                const stylesUrl = stylesResponse?.css?.widgetUrl;

                if (stylesUrl) {
                    dispatch(replaceSettingData({
                        key: 'customizations',
                        value: {
                            stylesUrl,
                        },
                    }));
                } else {
                    console.warn('No custom styles received - omitting application');
                }
            }
        } catch (error) {
            console.warn('Could not fetch custom styles - omitting application', e);
        }
    }
};

export const getData = params => async (dispatch, getState) => {
    const { settings: { dataSet, isLoading }, translations: { shouldTakeFromApi: shouldTakeLanguageFromApi } } = getState();

    // Params that for some reason don't have to be processed in API.getData
    const paramsToExcludeFromBootstrap = [];

    dispatch(dataRequestStart());

    try {
        // If echoApiUrl comes from settings, has to be prioritized against default echo backend url
        if (params?.echoApiUrl) {
            await API.replaceEchoUrl(params.echoApiUrl);
        }

        let apiParams = params;

        const inlineConfig = await WidgetConfigHelper.buildInitialConfig(params);
        const isUsingInlineStyles = !!inlineConfig?.customizations?.styles;

        const shouldTakeRedirectDomainFromApi = !params.domain;

        await dispatch(replaceSettingData({ key: 'shouldTakeRedirectDomainFromApi', value: shouldTakeRedirectDomainFromApi }));

        let cdnConfig; let apiConfig;

        try {
            cdnConfig = params.jsonFile ? await API.getConfigFromCdn(params.jsonFile) : undefined;
        } catch (error) {
            cdnConfig = undefined;
        }

        const inlineDomain = inlineConfig?.settings?.domain;
        const knownDomainWithoutStyles = inlineDomain &&
            (inlineDomain === 'https://bookings.coralmistbarbados.com/' || inlineDomain === 'https://bookings.blueorchidsbarbados.com/');
        if (knownDomainWithoutStyles) {
            inlineConfig.customizations = { styles: '' };
        }

        let result = {
            ...inlineConfig,
            settings: { ...inlineConfig.settings, ...cdnConfig && cdnConfig.settings },
            customizations: { ...inlineConfig.customizations, ...cdnConfig && cdnConfig.customizations },
            rates: [],
            offers: [],
        };

        const previousSettings = getState().settings.data;

        try {
            apiParams = apiParams.isMultiProperty
                ? WidgetConfigHelper.disableRatesAndOffers(apiParams) : apiParams;

            apiParams = params.widgetType === ECHO_WIDGET ? {
                ...apiParams,
                customizations: {
                    ...apiParams.customizations,
                    rates: { isDisabled: false },
                    offers: { isDisabled: true },
                },
            } : apiParams;

            if (!apiParams.domain) {
                apiParams.domain = inlineConfig.settings.domain;
            }

            const { settings: { language } } = result;

            const domain = result.domain || result.settings.domain;

            const shouldNotAskForConfig = dataSet || isLoading;

            if (result.settings.maxCheckoutDate) {
                paramsToExcludeFromBootstrap.push('maxCheckoutDate');
            }

            // If language wasn't set, I have to default it to undefined, so bootstrap resolves it  itself
            apiConfig = !shouldNotAskForConfig
                ? await API.getData(
                    { domain, user: { language: language || undefined, userAgent: navigator.userAgent } },
                    paramsToExcludeFromBootstrap,
                )
                : apiConfig;

            if (apiConfig) {
                if (apiConfig.meta?.ipAddress) {
                    dispatch(replaceSettingData({
                        key: 'ipAddress',
                        value: apiConfig.meta?.ipAddress,
                    }));
                }

                const cutoff = inlineConfig.cutoff || (cdnConfig && cdnConfig.cutoff) || (apiConfig.settings.minNightOffset);

                const los = inlineConfig?.settings?.los || (apiConfig.settings?.los);
                const validDate = sanitizeDate(
                    inlineConfig?.settings.checkIn,
                    inlineConfig?.settings.checkOut,
                    { checkIn: apiConfig.settings.checkIn, checkOut: apiConfig.settings.checkOut },
                    los,
                    cutoff,
                );
                result.settings.checkIn = validDate.checkIn;
                result.settings.checkOut = validDate.checkOut;

                result = {
                    ...result,
                    settings: { ...apiConfig.settings, ...filterByNoUndefined(result.settings) },
                    customizations: { ...apiConfig.customizations, ...filterByNoUndefined(result.customizations) },
                    rates: [],
                    offers: [],
                };
            }

            // Fixes if in widget config availableLanguages is not present and current language is not 'en'
            if (!result.settings?.availableLanguages?.length) {
                result.settings.availableLanguages = previousSettings.availableLanguages?.length
                    ? [ ...previousSettings.availableLanguages ]
                    : [ DEFAULT_FALLBACK_LANGUAGE ];
            }
            // Fixes if in widget config availableLanguages is provided without including current language
            if (result?.settings?.language && !result.settings.availableLanguages.includes(result.settings?.language)) {
                result.settings.availableLanguages.push(result.settings.language);
            }

            // Detect filters in the url and dispatch them to the redux store
            const isMultiProperty = result.settings.isMultiProperty || apiParams.isMultiProperty;
            if (result.filterParams && isMultiProperty) {
                const { minPrice, maxPrice, countries, mealPlans, propertyTypes } = result.filterParams;

                if (minPrice !== undefined || maxPrice !== undefined) {
                    const minPriceFilter = minPrice !== undefined ? parseFloat(minPrice) : undefined;
                    const maxPriceFilter = maxPrice !== undefined ? parseFloat(maxPrice) : undefined;
                    dispatch(changePriceFilter(minPriceFilter, maxPriceFilter));
                }
                if (countries && Array.isArray(countries) && countries.length > 0) {
                    dispatch(changePropertiesByCountryCode(countries));
                }
                if (mealPlans && Array.isArray(mealPlans) && mealPlans.length > 0) {
                    dispatch(changeCheckboxesFilter('mealPlans', mealPlans));
                }
                if (propertyTypes && Array.isArray(propertyTypes) && propertyTypes.length > 0) {
                    dispatch(changeCheckboxesFilter('propertyTypes', propertyTypes));
                }
            }
        } catch (error) {
            apiConfig = undefined;
            dispatch(dataRequestFailure(error));
        }

        const cutoff = inlineConfig.cutoff || (cdnConfig && cdnConfig.cutoff) || (apiConfig && apiConfig.cutoff);

        if (cutoff) {
            result.settings.minNightOffset = cutoff;
        }

        const { widgetType } = result;
        result.settings.widgetType = widgetType;

        if (widgetType === ECHO_WIDGET) {
            try {
                const userInfo = await API.getUserInfo();
                const userCurrency = userInfo?.currency;
                const { channelId: userChannelId, clientPromoCode } = userInfo;
                await dispatch(changeCurrency(userCurrency));
                if (userChannelId) {
                    await dispatch(replaceSettingData({ key: 'channelId', value: userChannelId }));
                }

                if (clientPromoCode) {
                    await dispatch(setSearchKey({ key: 'clientPromoCode', value: clientPromoCode }));
                }
            } catch (error) {
                await dispatch(setCurrencyType('pts'));
            } finally {
                await dispatch(setConfig(inlineConfig.id, 'searchbar', { showCurrencySelector: false }));
                result.settings.currency = {
                    code: 'pts',
                    symbol: '',
                };
            }
        }

        if (!result.customizations.config) {
            result.customizations.config = { id: inlineConfig.id };
        } else {
            // eslint-disable-next-line dot-notation
            result.customizations.config['id'] = inlineConfig.id;
        }

        if (result.settings.alternativeOffers) {
            await dispatch({ type: 'UPDATE_ALTERNATIVE_OFFERS', payload: result.settings.alternativeOffers });
        }

        Object.keys(DEFAULT_VALUES).forEach((key) => {
            // I only want to check for null and undefined values. If they were previously set, I keep that value.
            // Otherwise, I choose the default value.
            if ((result.settings[key] === null || result.settings[key] === undefined)) {
                result.settings[key] = previousSettings[key] ?? DEFAULT_VALUES[key];
            }
        });

        Object.keys(result.customizations).forEach((key) => {
            const shouldTakeFromApi = (!result.customizations[key] && !!apiConfig?.customizations && apiConfig.customizations[key]);
            const isForcingLocalValue = key === 'stylesUrl' && isUsingInlineStyles;

            result.customizations[key] = (shouldTakeFromApi && !isForcingLocalValue)
                ? apiConfig.customizations[key]
                : result.customizations[key];
        });

        // Due to a difference in key's name between the project and channel settings
        if (result.settings.promotionCodeEnabled !== undefined) {
            result.settings.promotionalCodeEnabled = result.settings.promotionCodeEnabled;
            delete result.settings.promotionCodeEnabled;
        }

        // Fixes if an invalid language is written in widget config
        result.settings.availableLanguages = result.settings.availableLanguages?.filter(
            language => AVAILABLE_LANGUAGES.includes(language) || AVAILABLE_LANGUAGES.includes(language.toLowerCase()),
        )
            .map(language => language.toLowerCase());

        result.settings.language = !shouldTakeLanguageFromApi ? result.settings.language.toLowerCase() : apiConfig.settings.language;
        result.settings.preferredLocales = getPreferredLocales();
        result.settings.defaultCurrency = result.settings.currency;

        if (isUsingInlineStyles) {
            result.customizations.isUsingInlineStyles = true;
            result.customizations.stylesUrl = undefined;
        }

        await dispatch(dataRequestSuccess(result));
        await dispatch(getStyles());

        return {
            settings: result.settings,
            customizations: result.customizations,
        };
    } catch (e) {
        return dispatch(dataRequestFailure(e));
    }
};

export function getPreferredLocales() {
    if (typeof navigator === 'undefined') {
        return [];
    }

    const languages = navigator.languages || [];
    return languages.map(lang => lang.toLowerCase());
}

export const reloadRatesAndOffers = (id) => async (dispatch, getState) => {
    const { settings, search, rates: { isLoading } } = getState();
    const { propertyCode, sortOrder = 'native', widgetType, channelId: backUpChannelId,
        priceCalcMode, priceDisplayMode } = settings.data;

    if (isLoading) {
        return;
    }

    const currentWidget = await dispatch(getWidgetSet(id));
    const { channelId } = currentWidget.config;

    const { packageCodes = '', categories: packageCategories = '' } = currentWidget.offers ?? {};
    const { roomCodes = '', categories: roomCategories = '' } = currentWidget.rates ?? {};

    const {
        language, currency, checkIn, checkOut, occupancy, clientPromoCode,
    } = search.data;

    const isConnected = currentWidget.searchbar.isConnected;

    const params = {
        channelId: !channelId || channelId?.length === 0 ? backUpChannelId : channelId,
        propertyCode,
        checkIn,
        checkOut,
        language,
        sortOrder,
        promotionalCode: clientPromoCode,
        occupancy: occupancy[0],
        currency: currency.code,
        priceCalcMode,
        priceDisplayMode,
        packageCodes,
        packageCategories,
        roomCodes,
        roomCategories,
    };

    try {
        dispatch(ratesAndOffersRequestStart());
        let response = await API.getRates(params, widgetType);
        let shouldUpgradeTier; let shouldHideHotel;
        if (!isConnected) {
            shouldUpgradeTier = false;
            shouldHideHotel = false;
        } else {
            shouldHideHotel = response.warnings?.shouldHideHotel;
            shouldUpgradeTier = response.warnings?.shouldUpgradeTier;
        }

        const shouldSetWarning = shouldUpgradeTier || shouldHideHotel;
        if (shouldSetWarning) {
            const keyToSet = Object.keys(response.warnings).find(key => !!response.warnings[key]);
            await dispatch(setRoomsWarning({ key: keyToSet, value: response.warnings[keyToSet] }));
        } else {
            // No warning set, have to update previous values
            shouldHideHotel = response.shouldHideHotel;
            shouldUpgradeTier = response.shouldUpgradeTier;
            await dispatch(setRoomsWarning({ key: 'shouldHideHotel', value: shouldHideHotel }));
            await dispatch(setRoomsWarning({ key: 'shouldUpgradeTier', value: shouldUpgradeTier }));
        }

        const { staticInfoRequested } = response.warnings ?? { staticInfoRequested: false };

        // If staticInfoRequested is true and the other flags no, then login button must be shown. Next line checks it
        if (staticInfoRequested && !shouldUpgradeTier && !shouldHideHotel) {
            response = {
                ...response,
                shouldShowLogin: true,
            };
        }

        // Otherwise, the default value has to be replaced
        if (!staticInfoRequested) {
            response = {
                ...response,
                shouldShowLogin: false,
            };
        }

        dispatch(ratesAndOffersRequestSuccess(response));

        return response;
    } catch (e) {
        dispatch(ratesAndOffersRequestFailure(e));
        return;
    }
};

export const clearFuturePackages = (id) => async (dispatch) => {
    dispatch(futureOffersRequestSuccess([]));
};

export const updateFuturePackages = (id) => async (dispatch, getState) => {
    const { offers } = getState();
    const widgetSet = dispatch(getWidgetSet(id));
    const offersConfiguration = widgetSet?.offers;

    if (!offersConfiguration) {
        return;
    }

    const { numberOfOffers } = offersConfiguration;
    const isOffersWidgetRendered = offersConfiguration.isRendered;

    if (!isOffersWidgetRendered) {
        return;
    }

    const currentlyLoadedOffers = offers?.data || [];
    const isFuturePackageFetchRequired = currentlyLoadedOffers && currentlyLoadedOffers.length < numberOfOffers;

    await dispatch(clearFuturePackages(id));
    if (isFuturePackageFetchRequired) {
        await dispatch(reloadFuturePackages(id));
    }
};

export const reloadFuturePackages = (id) => async (dispatch, getState) => {
    const currentWidget = dispatch(getWidgetSet(id));
    const { channelId } = currentWidget.config;

    const { settings, search, offers } = getState();
    const { language, currency, checkIn, checkOut, occupancy, clientPromoCode, userAgent } = search.data;
    const { propertyCode, channelId: backUpChannelId, priceCalcMode, ipAddress } = settings.data;
    const childAges = (occupancy.children || []).map(age => (age >= 0 ? age : 12));
    const priceDisplayMode = settings.data.priceDisplayMode === 'stay'
        ? 'perStay'
        : settings.data.priceDisplayMode || 'perStay';

    try {
        dispatch(futureOffersRequestStart());

        const earliestBookableDate = await API.getEarliestBookingDates(propertyCode, new URLSearchParams([
            [ 'propertyCode', propertyCode ],
            [ 'numberOfAdults', occupancy[0].adults ],
            [ 'startDate', checkIn ],
            [ 'childAges', childAges ],
            [ 'checkIn', checkIn ],
            [ 'checkOut', checkOut ],
            [ 'languageCode', language ],
            [ 'channelId', !channelId || channelId?.length === 0 ? backUpChannelId : channelId ],
            [ 'userAgent', userAgent ],
            [ 'promotionCode', clientPromoCode ],
            [ 'userIP', ipAddress ],
            [ 'currencyCode', currency.code ],
            [ 'includePrice', true ],
            [ 'ratePlanTypes', 'PACKAGE' ],
            [ 'ratePlanTypes', 'DERIVED_PACKAGE' ],
            [ 'priceType', priceCalcMode ],
            [ 'priceMode', priceDisplayMode ],
        ]));

        const { earliestBookable } = earliestBookableDate.result;
        const bookablePackages = [];

        (earliestBookable.rooms || []).forEach(room => {
            room.ratePlans.forEach(ratePlan => bookablePackages.push(ratePlan));
        });

        const packageOffers = {
            'skd-property-code': propertyCode,
            token: 42,
            'skd-packages': true,
            'skd-filter-by-price': false,
            'skd-start': checkIn,
            'skd-language-code': language,
        };

        const existingPackageCodes = offers.data.map(offer => offer.code);
        const isAdditionalPackage = (packageCode) => !existingPackageCodes.includes(packageCode);

        const futurePackages = bookablePackages.filter(bookable => isAdditionalPackage(bookable.code));

        if (!futurePackages.length) {
            dispatch(futureOffersRequestSuccess([]));
            return [];
        }

        const rateCodes = new URLSearchParams();
        futurePackages.forEach(futurePackage => rateCodes.append('skd-rate-code', futurePackage.code));

        const ratesAvg = await API.getRatesAverage(packageOffers, rateCodes);
        const ratesAvgPackages = ratesAvg?.result?.packages || [];
        const { packageCodes = '', categories: packageCategories = '' } = currentWidget.offers ?? {};
        const enabledPackageCodes = !!packageCodes
            ? packageCodes.split(',').map(code => code.trim())
            : [];
        const enabledPackageCategories = !!packageCategories
            ? packageCategories.split(',').map(category => category.trim())
            : [];
        const isPackageCodeEnabled = (packageCode) => !enabledPackageCodes?.length || enabledPackageCodes.includes(packageCode);
        const isPackageCategoryEnabled = (packageCategories) =>
            !enabledPackageCategories?.length || packageCategories.some(category => enabledPackageCategories.includes(category));

        const packagesWithRates = ratesAvgPackages
            .filter(p => isPackageCodeEnabled(p.code))
            .filter(p => isPackageCategoryEnabled(p.category_codes))
            .map(p => mapPackage(p, futurePackages))
            .sort((next, current) => moment(next.availableDaterange.start) - moment(current.availableDaterange.start));

        dispatch(futureOffersRequestSuccess(packagesWithRates));

        return packagesWithRates;
    } catch (e) {
        dispatch(futureOffersRequestFailure(e));

        return [];
    }
};

export const mapPackage = (rateAvgPackage, futurePackages) => {
    const futurePackage = futurePackages
        .filter(fp => fp.code === rateAvgPackage.code)
        .sort((a, b) => b.price - a.price)
        .pop();
    const price = futurePackage.price;
    const availableDaterange = {
        start: futurePackage.date,
        end: moment(futurePackage.date).add(futurePackage.minLos, 'days').format('YYYY-MM-DD'),
    };

    return {
        ...rateAvgPackage,
        images: getCroppedImages(rateAvgPackage.imagesInfo),
        title: rateAvgPackage.title || rateAvgPackage.code,
        price,
        availableDaterange,
    };
};

export const getHotelProfile = params => async (dispatch, getState) => {
    try {
        dispatch(hotelProfileRequestStart());
        const { userAgent } = getState().search.data;
        const domain = params.domain ? params.domain : WidgetConfigHelper.buildDomain(params);
        const language = params.language || DEFAULT_FALLBACK_LANGUAGE;
        const propertyParams = {
            domain,
            user: {
                language,
                userAgent,
            },

        };
        const response = await API.getPropertyInfo(propertyParams);
        return dispatch(hotelProfileRequestSuccess(response));
    } catch (e) {
        return dispatch(hotelProfileRequestFailure(e));
    }
};

export const getTrackingModules = () => async () => {
    try {
        const response = await API.getTrackingModules();
        return response;
    } catch (e) {
        return e;
    }
};

export const getUserCountry = () => async (dispatch, getState) => {
    const { settings, search } = getState();

    const { domain, language: languageCode } = settings.data;
    const { userAgent } = search.data;

    const requestParams = { domain, languageCode, userAgent };

    const response = await API.getUserCountry(requestParams);

    const { userCountry } = response;

    if (userCountry) {
        dispatch(replaceSettingData({ key: 'userCountry', value: userCountry }));
        return Promise.resolve(userCountry);
    }

    return Promise.resolve(false);
};

export const getIp = () => async (dispatch) => {
    try {
        const ip = await API.getIpURL();
        dispatch(replaceSettingData({ key: 'ipAddress', value: ip }));
        return Promise.resolve(ip);
    } catch (error) {
        return Promise.resolve('');
    }
};

export const replaceVoucherTerm = lang => async (dispatch, getState) => {
    const { settings } = getState();
    const { domain } = settings.data;
    const params = { domain, user: { language: lang, userAgent: navigator.userAgent }, source: 'widget' };
    await API.getChannelData(params).then((res) => {
        const { channelSettings: { couponVoucherTerm } } = res;
        dispatch(replaceSettingData({ key: 'couponVoucherTerm', value: couponVoucherTerm }));
    });
};
